module.exports = __webpack_public_path__ + "static/media/khalti-logo.6faf44ec.jfif";